module.exports = __webpack_public_path__ + "img/rdx-slide-2.934c0f3.png";